import React from 'react';
import { colorTypeHelper } from 'utils/colorUtility';
import InPageFeaturesV1 from './InPageFeaturesV1';
import InPageFeaturesV2 from './InPageFeaturesV2';
import InPageFeaturesV3 from './InPageFeaturesV3';
import InPageFeaturesV3New from './InPageFeaturesV3New';
import InPageFeaturesV4 from './InPageFeaturesV4';
import InPageFeaturesV5 from './InPageFeaturesV5';
import InPageFeaturesV6 from './InPageFeaturesV6';
import InPageFeaturesV7 from 'components/Contentful/ContentfulInPageFeatures/InPageFeaturesV7';
import InPageResource from './InPageResource';

const ContentfulInPageFeatures = (props) => {
  const { sectionStyle, description, bgColor, index } = props || {};

  switch (sectionStyle) {
    case 'V2 Style':
      return (
        <InPageFeaturesV2
          {...props}
          description={description?.description || ''}
          backgroundColor={colorTypeHelper[bgColor]}
        />
      );
    case 'V3 Style':
      return (
        <>
          <InPageFeaturesV3 {...props} index={index} />
          <InPageFeaturesV3New {...props} index={index} />
        </>
      );
    case 'V4 Style':
      return <InPageFeaturesV4 {...props} />;
    case 'V5 Style':
      return <InPageFeaturesV5 {...props} />;
    case 'V7 Style':
      return <InPageFeaturesV7 {...props} />;
    case 'V6 Style':
    case 'Commercial Section Style': // Remove this line once this PR is released
      return (
        <InPageFeaturesV6
          {...props}
          description={description?.description || ''}
          backgroundColor={colorTypeHelper[bgColor]}
        />
      );
    case 'Resource Section Style':
      return (
        <InPageResource
          {...props}
          description={description?.description || ''}
          backgroundColor={colorTypeHelper[bgColor]}
        />
      );
    default:
      return (
        <InPageFeaturesV1
          {...props}
          description={description?.description || ''}
          backgroundColor={colorTypeHelper[bgColor]}
        />
      );
  }
};

export default ContentfulInPageFeatures;
